import { lazyNamed } from 'src/utils/lazyNamed';

export const Invoicing = {
  InvoicingList: lazyNamed(() => import('./containers/InvoicingList'), 'InvoicingList'),
};
